import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { OwnerImageLink } from './OwnerImageLink';

export type AboutOwnerProps = {
  logo: string | null;
  name: string;
  ownerUrl: string;
  parentOwnerName?: string;
  parentOwnerUrl?: string;
  description: string;
  registrationNumber?: string;
  webAddress?: string;
};
const AboutOwner: FunctionComponent<AboutOwnerProps> = ({
  logo,
  name,
  ownerUrl,
  parentOwnerName,
  parentOwnerUrl,
  description,
  registrationNumber,
  webAddress,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <>
      {logo && (
        <OwnerImageLink
          name={name}
          ownerUrl={ownerUrl}
          qaIdentifier="owner-logo"
          itemProp="logo"
          logo={logo}
        />
      )}
      <h2 itemProp="name">
        <a className="jg-text--regular" href={ownerUrl}>
          {name}
        </a>
        {parentOwnerName && (
          <div className="jg-h6" data-qa="parent-owner">
            {t('common.runby', 'run by ')}
            <a className="jg-text--regular" href={parentOwnerUrl}>
              {parentOwnerName}
            </a>
          </div>
        )}
      </h2>
      <p itemProp="description" className="jg-text--large">
        {description}
      </p>
      {registrationNumber && (
        <p
          data-qa="charity-registration-number"
          className="jg-text--small-light jg-space-mbn"
          itemProp="identifier"
        >
          {t('charity.registrationNumberLabel', 'Charity Registration No. ')}
          {registrationNumber}
        </p>
      )}
      {webAddress && (
        <p
          data-qa="owner-url"
          itemProp="url"
          className="jg-text--small-light jg-space-mbn"
        >
          {webAddress}
        </p>
      )}
    </>
  );
};

export default AboutOwner;
